import React, { memo } from 'react';
import { IEvent } from '~/Models/DTO/Event.model';

import { makeStyles } from '~/UIKit/Style';
import { DraggableEvent, DraggableType } from '~/Screens/Calendar/CalendarView/components/';
import { FULL_DAY_ACTIVITY_HEIGHT } from '~/Screens/Calendar/constants';

const useStyles = makeStyles(
  () => ({
    container: {
      color: 'initial',
      width: '100%',
      height: '100%',
      position: 'relative',
      fontWeight: 'initial',
    },
  }),
  { name: 'CalendarView' },
);

interface ICalendarFullDayActivity {
  width: number;
  events?: IEvent[];
  daysOffset?: number;
}

export const CalendarFullDayActivity = memo(
  ({ events, width, daysOffset = 0 }: ICalendarFullDayActivity) => {
    const { classes } = useStyles();

    if (!events) {
      return null;
    }

    return (
      <div
        className={classes.container}
        style={{ height: FULL_DAY_ACTIVITY_HEIGHT * events.length }}
      >
        {events.map((event, idx) => (
          <DraggableEvent
            key={event.id}
            type={DraggableType.FULL_DAY_ACTIVITY}
            event={event}
            position={{
              top: FULL_DAY_ACTIVITY_HEIGHT * idx,
              left: 0,
              width,
              daysOffset,
              height: FULL_DAY_ACTIVITY_HEIGHT,
            }}
          />
        ))}
      </div>
    );
  },
);
